/**
 * Sparkline — 13 net-worth points on the home screen (spec §6.4): one series, no axes,
 * an 8px end marker with a surface-coloured ring, `role="img"` + `aria-label` (the only chart
 * that may use `role="img"`, because it has no focusable children).
 */

import { areaPath, linePath } from './chart-utils.ts';
import { useChartWidth } from './useChartWidth.ts';

export function Sparkline({ values, label }: { values: number[]; label: string }) {
  const [ref, width] = useChartWidth(240);
  const height = 48;
  const pad = 6;
  if (values.length < 2) return <div ref={ref} />;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const points = values.map((value, index): [number, number] => [
    pad + (index * (width - 2 * pad)) / (values.length - 1),
    height - pad - ((value - min) / span) * (height - 2 * pad),
  ]);
  const last = points[points.length - 1]!;
  return (
    <div ref={ref}>
      <svg className="spark" viewBox={`0 0 ${width} ${height}`} width={width} height={height} role="img" aria-label={label}>
        <path d={areaPath(points, height - 1)} className="s1" style={{ opacity: 0.1 }} />
        <path d={linePath(points)} fill="none" className="ls1" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        <circle cx={last[0].toFixed(1)} cy={last[1].toFixed(1)} r="4" className="s1 marker" />
      </svg>
    </div>
  );
}
